import { YmEventGoals } from './js/constants/YmEventGoals';
import YmSendGoal from './js/helpers/YmSendGoal';
import { serviceWorkerRegister } from './js/sw';

let elemProgressItems = document.querySelectorAll('.js-progress-item');
let elemText = document.querySelector('.js-progress-text');
let elemFill = document.querySelector('.js-progress-fill');
let elemCounter = document.querySelector('.js-counter');

const totalProgressItems = elemProgressItems.length;

export const progress = (p) => {
    document.body.setAttribute('data-preloader-progress', p);
    Array.from(elemProgressItems).slice(0, Math.round(p * totalProgressItems)).forEach((el) => { el.style.opacity = 1; });
    if (elemText) elemText.innerHTML = `${Math.round(p * 100)}%`;
    if (elemFill) elemFill.style.transform = `scale(${p}, 1)`;
    if (elemCounter) elemCounter.dataset.value = Math.round((1 - p) * 10);
};

progress(0);

export const loadDone = async () => {
    const { body } = document;

    const pelem = document.querySelector('.preloader');

    pelem.classList.add('loaded');

    setTimeout(() => {
        progress(1);
        body.classList.remove('preload');

        setTimeout(() => {
            if (pelem && pelem.parentNode) {
                pelem.parentNode.removeChild(pelem);
                elemText = undefined;
                elemFill = undefined;
                elemCounter = undefined;
                elemProgressItems = undefined;

                YmSendGoal(YmEventGoals.SHOW_BETCITY);
            }
        }, 1200);
    }, 500);

    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        serviceWorkerRegister();
    }
};
